import { jsx } from "react/jsx-runtime";
import { ContentType } from "../../../enums/contentStack.js";
import { getConfigurationSettingByDevelopmentKey } from "../../../services/content/config.lib.js";
import { QueryParamsProvider } from "../../../utils/QueryParamsProvider/QueryParamsProvider.js";
import { isVisibleOnWeb } from "../../../utils/contentstack/webApplicability.js";
import { AdBuilderWrapper } from "../AdSet/AdBuilderWrapper/index.js";
import { AdButler } from "./AdButler/index.js";
import { AdobeAdSet } from "./Adobe/AdobeAdSet.js";
import { CriteoAdSet } from "./Criteo/CriteoAdSet.js";
import { LucidWorksAdSet } from "./LucidWorks/LucidWorksAdSet.js";
import { AD_BUTLER_CONTENTSTACK_DEVELOPMENT_KEY, AD_SOURCE_CRITEO, AD_SOURCE_ADOBE, AD_SOURCE_AD_BUTLER, AD_SOURCE_LW } from "./constants.js";
async function AdSetThirdParty({
  entry,
  locale,
  titleProps,
  isSearchPage = false,
  isCategoryPage = false,
  isProductDetailsPage = false,
  maxSlides,
  maxSlidesBySize,
  productTileSx,
  carouselContainerSx,
  sx,
  contextData
}) {
  var _a, _b;
  if (!isVisibleOnWeb(entry)) {
    return null;
  }
  const { item_curation } = entry;
  const isCriteo = item_curation === AD_SOURCE_CRITEO;
  const isAdobe = item_curation === AD_SOURCE_ADOBE;
  const isAdButler = item_curation === AD_SOURCE_AD_BUTLER;
  const isLucidWorks = item_curation === AD_SOURCE_LW;
  if (isCriteo) {
    return /* @__PURE__ */ jsx(
      CriteoAdSet,
      {
        carouselContainerSx,
        contentStackEntry: entry,
        isCategoryPage,
        isProductDetailsPage,
        isSearchPage,
        locale,
        maxSlides,
        maxSlidesBySize,
        productTileSx,
        sx,
        titleProps
      }
    );
  }
  if (isAdobe) {
    return /* @__PURE__ */ jsx(QueryParamsProvider, { children: /* @__PURE__ */ jsx(
      AdBuilderWrapper,
      {
        entry,
        linkId: !(titleProps == null ? void 0 : titleProps.title) ? titleProps == null ? void 0 : titleProps.titleId : void 0,
        locale,
        children: /* @__PURE__ */ jsx(
          AdobeAdSet,
          {
            carouselContainerSx,
            contextData,
            entry,
            isProductDetailsPage,
            locale,
            maxSlides,
            maxSlidesBySize,
            productTileSx,
            sx,
            titleProps
          }
        )
      }
    ) });
  }
  if (isAdButler) {
    const adButlerConfigData = await getConfigurationSettingByDevelopmentKey(
      ContentType.ServiceConfiguration,
      AD_BUTLER_CONTENTSTACK_DEVELOPMENT_KEY
    );
    const SITE = locale === "en-us" ? "USBC" : "CABC";
    const siteId = adButlerConfigData.required_request_parameters[SITE].ID;
    const kw = (_b = (_a = adButlerConfigData.required_request_parameters[SITE]) == null ? void 0 : _a.kw) == null ? void 0 : _b[locale];
    return /* @__PURE__ */ jsx(QueryParamsProvider, { children: /* @__PURE__ */ jsx(
      AdButler,
      {
        adButlerConfigData: { kw, siteId },
        entry,
        isSearchPage,
        locale,
        titleProps,
        maxSlidesBySize
      }
    ) });
  }
  if (isLucidWorks) {
    return /* @__PURE__ */ jsx(
      LucidWorksAdSet,
      {
        isProductDetailsPage,
        entry,
        locale,
        contextData,
        titleProps
      }
    );
  }
  return null;
}
export {
  AdSetThirdParty
};
